export const legacyBoxRoutePrefix = "/boxes/";
export const productRoutePrefixes = Object.freeze({
  tetoboxok: "/tetoboxok/",
  kerekpartartok: "/kerekpartartok/",
  "teli-sportok": "/teli-sportok/"
});
export const adminRoute = "/admin";
export const termsRoute = "/aszf";
export const privacyNoticeRoute = "/adatkezelesi-tajekoztato";
export const rentalAgreementRoute = "/berleti-szerzodes";
export const externalLoginRoutePrefix = "/oauth-complete";
export const resetPasswordRoutePrefix = "/reset-password";

export const homeSectionRoutes = Object.freeze({
  "/tetoboxok": "roof-boxes",
  "/kerekpartartok": "bike-racks",
  "/teli-sportok": "ski-snowboard",
  "/arak": "prices",
  "/gyik": "faq",
  "/kapcsolat": "contact"
});

function normalizePath(pathname) {
  if (!pathname || pathname === "/") {
    return "/";
  }

  return pathname.replace(/\/+$/g, "");
}

function buildRouteFromUrl(url) {
  const pathname = normalizePath(url.pathname);
  return `${pathname}${url.search}`;
}

export function createBoxRouteSlug(name) {
  return name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function createProductRouteSlug(name) {
  const slug = createBoxRouteSlug(name);
  const slugOverrides = {
    "thule-proride": "thule-proride-591",
    "thule-velocompact": "thule-velocompact-926"
  };

  return slugOverrides[slug] ?? slug;
}

export function createProductRoute(section, slug) {
  const prefix = productRoutePrefixes[section] ?? productRoutePrefixes.tetoboxok;
  return `${prefix}${slug}`;
}

export function getHash() {
  return buildRouteFromUrl(new URL(window.location.href));
}

export function getSelectedBoxId(route) {
  const url = new URL(route || "/", window.location.origin);
  const matchingPrefix = [legacyBoxRoutePrefix, ...Object.values(productRoutePrefixes)]
    .find(prefix => url.pathname.startsWith(prefix));

  return matchingPrefix ? url.pathname.replace(matchingPrefix, "") : null;
}

export function getProductRouteSection(route) {
  const url = new URL(route || "/", window.location.origin);

  if (url.pathname.startsWith(legacyBoxRoutePrefix)) {
    return "legacy";
  }

  return Object.entries(productRoutePrefixes)
    .find(([, prefix]) => url.pathname.startsWith(prefix))?.[0] ?? null;
}

export function getHomeSectionId(route) {
  const url = new URL(route || "/", window.location.origin);
  return homeSectionRoutes[normalizePath(url.pathname)] ?? null;
}

export function getHomeSectionRoute(sectionId) {
  const normalizedSectionId = sectionId.replace(/^#/, "");
  return Object.entries(homeSectionRoutes).find(([, id]) => id === normalizedSectionId)?.[0] ?? "/";
}

export function isAdminHash(route) {
  const url = new URL(route || "/", window.location.origin);
  return url.pathname === adminRoute;
}

export function getPasswordResetParams(route) {
  const url = new URL(route || "/", window.location.origin);

  if (url.pathname !== resetPasswordRoutePrefix) {
    return null;
  }

  const email = url.searchParams.get("email") ?? "";
  const token = url.searchParams.get("token") ?? "";

  return email && token ? { email, token } : null;
}

export function getExternalLoginTicket(route) {
  const url = new URL(route || "/", window.location.origin);

  if (url.pathname !== externalLoginRoutePrefix) {
    return null;
  }

  return url.searchParams.get("ticket");
}

export function toRoutePath(pathname, search = "") {
  const normalizedPath = normalizePath(pathname);
  return `${normalizedPath}${search}`;
}
